module.exports = __webpack_public_path__ + "img/icone-imagem-cuco.baea12bf.png";